import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { FeaturedProducts } from "@/components/FeaturedProducts";
import { CategoryMenu } from "@/components/CategoryMenu";
import { Manifesto } from "@/components/Manifesto";
import { NewsletterSection } from "@/components/NewsletterSection";

export default function HomePage() {
    return (
        <main data-testid="home-page">
            <Hero />
            <EditorialMarquee />
            <FeaturedProducts />
            <CategoryMenu />
            <Manifesto />
            <NewsletterSection />
        </main>
    );
}
